module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._c;
  return _c('div', {
    staticClass: "footerContainer"
  }, [(!_vm.isEnglish) ? _c('div', {
    staticClass: "links"
  }, [_c('div', {
    staticClass: "link-group"
  }, [_c('h1', [_vm._v(_vm._s(_vm.renderText("関連研究機関", "")))]), _c('ul', _vm._l((_vm.links), function(link) {
    return _c('li', [_c('a', {
      attrs: {
        "href": link.url,
        "target": "_blank"
      }
    }, [_vm._v(_vm._s(_vm.renderText(link.title.ja, link.title.en)))])])
  }))]), _c('div', {
    staticClass: "link-group"
  }, [_c('h1', [(!_vm.isEnglish) ? _c('span', [_vm._v("関連研究プロジェクト")]) : _vm._e(), (_vm.isEnglish) ? _c('span', [_vm._v("Lorem ipsum")]) : _vm._e()]), _c('ul', [_c('li', [(!_vm.isEnglish) ? _c('a', {
    attrs: {
      "href": "http://www.nihu.jp",
      "target": "_blank"
    }
  }, [_vm._v(_vm._s(_vm.renderText("人間文化研究機構「日本関連在外資料調査研究事業」プロジェクト（カテゴリーB）", "")))]) : _vm._e()])])])]) : _vm._e(), (!_vm.isEnglish) ? _c('p', {
    staticClass: "copy"
  }, [_vm._v("©" + _vm._s(_vm.copyrights.ja))]) : _vm._e()])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-62125bcc!./~/vue-loader/lib/template-loader.js?raw&engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/common/siteFooter.vue
// module id = 104
// module chunks = 1